import { useMemo } from 'react'

import { useParams } from '@Components/RouterProvider'
import createStore from '@Stores/base-factories'
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useBucketFactory = ({ fetch, siteSelected: { id: siteId, key } }) => {
  const { id } = useParams()

  return useMemo(() => ({
    collectionsURL: id ? `allocation/${id}/buckets` : null,
    credit: async payload => {
      const { ok } = await fetch({
        url: `allocation/${id}/bucket`,
        method: 'put',
        params: { [key]: siteId },
        data: payload,
      })
      return ok
    },
    reset: async payload => {
      const { ok } = await fetch({
        url: `allocation/${id}/bucket/reset`,
        method: 'put',
        params: { [key]: siteId },
        data: payload,
      })
      return ok
    },

  }), [id, fetch, key, siteId])
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extend(useBucketFactory)
  .extendHookCollectionsFactory()
  .factory()

export {
  Provider as BucketProvider,
  useStore as useBucketStore,
}
